import { messages } from "@/shared/i18n";

/**
 * Verify Email feature error code mappings
 *
 * Maps backend RFC 7807 Problem Details error codes to localized messages.
 */
export const VERIFY_EMAIL_ERROR_CODES: Record<string, string> = {
  "Email.Verification": messages.verifyEmail.errors.invalidToken,
  "SecureToken.TokenExpired": messages.verifyEmail.errors.invalidToken,
  "SecureToken.InvalidSignature": messages.verifyEmail.errors.invalidToken,
  "SecureToken.InvalidFormat": messages.verifyEmail.errors.invalidToken,
  "SecureToken.InvalidStructure": messages.verifyEmail.errors.invalidToken,
};
